<template>
  <div class="khattach">
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="ToggleProps"
      width="60%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>权限设置</span>
      </template>
      <template #default>
        <div style="overflow-y: scroll; height: 260px">
          <el-tree
            :data="functionRight"
            show-checkbox
            ref="tree"
            node-key="id"
            :default-checked-keys="GoupRight"
            :props="defaultProps"
          >
          </el-tree>
        </div>
      </template>
      <template #footer>
        <span class="dialog-footer">
          <el-row :gutter="20">
            <el-col :span="8" class="btnright">
              <el-button
                type="primary"
                size="medium"
                :disabled="saveOrdel"
                @click="saveEdit"
                >确 定</el-button
              >
              <el-button plain size="medium" @click="ToggleProps"
                >取 消</el-button
              >
            </el-col>
          </el-row>
        </span>
      </template>
    </vxe-modal>
  </div>
</template> 
<script>
// import { GetRight } from "@api/usergroup";
import { toRefs, ref, unref, reactive, onUpdated } from "vue";
import { ElMessage } from "element-plus";

export default {
  name: "usergroupRight",
  setup(props, content) {
    const OriginalData = () => {
      return {
        dialogVisible: false,
        defaultProps: {
          children: "children",
          label: "label",
        },
        functionRight: [],
        GoupRight: [],
        GroupID: "",
      };
    };
    let data = reactive(OriginalData());
    let tree = ref(null);
    const ToggleProps = () => {
      data.dialogVisible = false;
      Object.assign(data, OriginalData());
    };
    //初始化页面
    const initDialog = (CodeID) => {
      data.dialogVisible = true;
      data.GroupID = CodeID;
      GetRight(CodeID).then(function (result) {
        if (result.status == 200) {
          let resultInfo = result.data;
          data.functionRight = resultInfo.functionList;
          data.partRight = [];
          resultInfo.partList.map((item) => {
            data.partRight.push(item.FN_ID);
          });
        }
      });
    };

    function saveEdit() {
      //   let PART_ID = data.PART_ID;
      //   let PART_FUNCTIONS = tree.value.getCheckedKeys();
      //   if (PART_FUNCTIONS.length > 0) {
      //     PART_FUNCTIONS = JSON.stringify(PART_FUNCTIONS);
      //     var params = {
      //       PART_ID: PART_ID,
      //       PART_FUNCTIONS,
      //     };
      //     // this.$http
      //     //   .post("/api/main/insertsysPartFunction", params)
      //     //   .then((result) => {
      //     //     if (result.status == 200) {
      //     //       this.$emit("update:khattachVisible", false);
      //     //       this.saveOrdel = false;
      //     //       this.$message.success("保存成功");
      //     //     } else {
      //     //       //this.$emit("update:khattachVisible", false);
      //     //       this.saveOrdel = false;
      //     //       this.$message.error("保存失败");
      //     //     }
      //     //   });
      //   }
    }
    return {
      ...toRefs(data),
      ToggleProps,
      saveEdit,
      tree,
      initDialog,
    };
  },
};
</script>
<style scoped>
.khattach >>> .el-dialog__footer {
  text-align: center;
}
.khattach >>> .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
.khattach >>> .el-form-item__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.khattach >>> .el-input-number .el-input__inner {
  -webkit-appearance: none;
  text-align: left;
}
.khattach >>> .el-input-number--small {
  line-height: 30px;
  width: 100%;
}
.khattach >>> .el-input-number {
  position: relative;
  display: inline-block;
  width: 100%;
}
.khattach /deep/ .dialog-footer .el-row {
  margin: 0 !important;
}
.khattach /deep/ .btnright {
  float: right;
  padding: 0 !important;
  text-align: right;
}
.khattach /deep/ .el-tree-node__label {
  margin-left: 10px;
}
</style>

